import convertTimeToMilitaryFormat from "./convertTimeToMilitaryFormat";
import convertToMinutes from "./convertToMinutes";
import formatDate from "./formatDate";
import formatLocalDateTime from "./formatLocalDateTime";
import formatTableDate from "./formatTableDate";
import getAge from "./getAge";
export default {
  convertTimeToMilitaryFormat,
  convertToMinutes,
  formatDate,
  formatLocalDateTime,
  formatTableDate,
  getAge
};
//# sourceMappingURL=index.js.map